export default "__VITE_ASSET__DsJbuyJ0__"